export default __webpack_public_path__ + "static/media/Ballroll_00057.793f2a55.png";